export const ESignatureProduct = 'ShareFile - E-Signature';
export type EventMetadata = object;

export const SignatureRequestSentTrackEvent = 'Signature Request Sent';
export const SelfSignedTrackEvent = 'Self Signed';
export const EditedSignatureRequestSentEvent = 'Signature Request revision completed';
export const StartedSignatureRequestEditTrackEvent = 'Signature Request revision started';
export const SignatureRequestProgressSavedEvent = 'Signature Request progress saved';
export const SignatureRequestDeclinedEvent = 'Signature Request declined';
export const SignatureRequestSignedEvent = 'Signature Request signed';
export const SignatureRequestExecutedEvent = 'Signature Request executed';

const ESIGN_FOOTER_ANALYTICS_PREFIX = 'esignFooter';
const ESIGN_HEADER_ANALYTICS_PREFIX = 'esignHeaderCloseIcon';

// Do we need to change this prefix?
const DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX = 'DocgenSendSignatureRequest';

// Footer Next Button AnalyticsId
export const FooterNextButtonAnalyticsIds = {
	StartPage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}NextButton-StartPage`,
	PreparePage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}NextButton-PreparePage`,
	ReviewPageSaveCompletedDocument: `${ESIGN_FOOTER_ANALYTICS_PREFIX}SaveCompletedDocumentButton-ReviewPage`,
	ReviewPageSendSignatureRequest: `${ESIGN_FOOTER_ANALYTICS_PREFIX}SendSignatureRequestButton-ReviewPage`,
};

// Footer Previous Button AnalyticsId
export const FooterPreviousButtonAnalyticsIds = {
	PreparePage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}PreviousButton-PreparePage`,
	ReviewPage: `${ESIGN_FOOTER_ANALYTICS_PREFIX}PreviousButton-ReviewPage`,
};

// Header close icon AnalyticsId
export const HeaderCloseIconAnalyticsIds = {
	StartPage: `${ESIGN_HEADER_ANALYTICS_PREFIX}-StartPage`,
	PreparePage: `${ESIGN_HEADER_ANALYTICS_PREFIX}-PreparePage`,
	ReviewPage: `${ESIGN_HEADER_ANALYTICS_PREFIX}-ReviewPage`,
};

// Send Signature Request Footer Button AnalyticsId
export const SendSignatureRequestFooterAnalyticsIds = {
	NextStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-AddRecipientsPage`,
	NextStepAddFieldData: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-NextButton-AddFieldDataPage`,
	PreviousStepReviewAndSend: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-ReviewPage`,
	PreviousStepAddFieldData: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-AddFieldDataPage`,
	Customize: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-CustomizeButton`,
	SendSignatureRequest: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-SendSignatureRequestButton-ReviewPage`,
	StartOver: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-StartOverButton`,
	PreviousStepSelectRecipients: `${DOCGEN_SEND_SIGNATURE_REQUEST_ANALYTICS_PREFIX}-PreviousButton-AddRecipientsPage`,
};
